<template>
  <div class="clue-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Welcome' }">
            <i class="el-icon-s-home"></i> 首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <i class="el-icon-data-line"></i> 线索管理
          </el-breadcrumb-item>
          <el-breadcrumb-item>线索列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-icon icon-total">
          <i class="el-icon-data-line"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">总线索</div>
          <div class="stat-number">{{ total }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-follow">
          <i class="el-icon-time"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">跟进中</div>
          <div class="stat-number">{{ followCount }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-deal">
          <i class="el-icon-circle-check"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">已成交</div>
          <div class="stat-number">{{ dealCount }}</div>
        </div>
      </div>
    </div>

    <!-- 搜索筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-header">
        <i class="el-icon-search filter-icon"></i>
        <span class="filter-title">筛选查询</span>
      </div>

      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        ref="searchFormRef"
        class="filter-form"
      >
        <div class="filter-row">
          <el-form-item label="姓名">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入姓名"
              clearable
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>

          <el-form-item label="手机号">
            <el-input
              v-model="searchForm.mobile"
              placeholder="请输入手机号"
              clearable
              prefix-icon="el-icon-phone"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              clearable
              style="width: 200px;"
            >
              <el-option label="跟进中" :value="2"></el-option>
              <el-option label="已成交" :value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="action-buttons">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchSubmit"
              class="search-btn"
            >
              搜索
            </el-button>
            <el-button
              icon="el-icon-refresh"
              @click="resetSearch"
              class="reset-btn"
            >
              重置
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addData"
              class="add-btn"
            >
              新增线索
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-header-left">
          <i class="el-icon-s-data table-icon"></i>
          <span class="table-title">线索列表</span>
          <el-tag type="info" size="small" effect="plain">共 {{ total }} 条记录</el-tag>
        </div>
        <div class="table-header-right">
          <el-tooltip content="刷新数据" placement="top">
            <el-button
              icon="el-icon-refresh"
              size="small"
              circle
              @click="getList"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="导出数据" placement="top">
            <el-button
              icon="el-icon-download"
              size="small"
              circle
              @click="handleExport"
            ></el-button>
          </el-tooltip>
        </div>
      </div>

      <el-table
        :data="tableData"
        size="small"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
          fixed="left"
        >
          <template slot-scope="scope">
            <span class="index-badge">{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="姓名"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="clue-name">
              <i class="el-icon-user"></i>
              <span class="name-text">{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="手机号"
          width="130"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="contact-phone">
              <i class="el-icon-phone"></i>
              <span>{{ scope.row.mobile || '--' }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="性别"
          width="70"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sex === 1 ? '男' : scope.row.sex === 2 ? '女' : '--' }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="生日"
          width="110"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.birthday | dateFormat('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="状态"
          width="90"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 2 ? 'primary' : 'success'"
              size="small"
              effect="plain"
            >
              {{ scope.row.status === 2 ? '跟进中' : '已成交' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label="来源"
          width="110"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ getSourceName(scope.row.source_id) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="跟进人"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ getFollowerName(scope.row.follower_id) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="跟进阶段"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ getStepName(scope.row.step_id) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="备注"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span class="remark-text">{{ scope.row.remark || '--' }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="添加时间"
          width="160"
          sortable="custom"
          prop="add_time"
        >
          <template slot-scope="scope">
            <span class="time-text">{{ scope.row.add_time | dateFormat }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="200"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="goEdit(scope.row)"
                class="edit-btn"
              >
                编辑
              </el-button>

              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                class="delete-btn"
              >
                删除
              </el-button>

              <el-dropdown
                trigger="click"
                size="small"
                @command="(command) => handleCommand(command, scope.row)"
              >
                <span class="more-btn">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    icon="el-icon-view"
                    @click.native="goDetail(scope.row)"
                    command="detail"
                  >
                    查看详情
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.status === 2"
                    icon="el-icon-circle-check"
                    command="toDeal"
                    divided
                  >
                    标记为已成交
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-else
                    icon="el-icon-time"
                    command="toFollow"
                    divided
                  >
                    标记为跟进中
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @closed="handleDialogClosed"
      class="alipay-dialog"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formRef"
        label-width="100px"
        size="small"
        label-position="right"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入手机号" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="性别">
              <el-select v-model="form.sex" placeholder="请选择性别" style="width: 100%;">
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
                <el-option label="未知" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生日">
              <el-date-picker
                v-model="form.birthday"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%;">
                <el-option label="跟进中" :value="2"></el-option>
                <el-option label="已成交" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来源">
              <el-select v-model="form.source_id" placeholder="请选择来源" clearable style="width: 100%;">
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="跟进人">
              <el-select v-model="form.follower_id" placeholder="请选择跟进人" clearable style="width: 100%;">
                <el-option
                  v-for="item in followerOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="跟进阶段">
              <el-select v-model="form.step_id" placeholder="请选择阶段" clearable style="width: 100%;">
                <el-option
                  v-for="item in stepOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="2"
            placeholder="请输入备注"
            maxlength="255"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitForm" size="small" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="线索详情"
      :visible.sync="detailVisible"
      width="560px"
      class="alipay-dialog"
    >
      <el-descriptions :column="1" border>
        <el-descriptions-item label="姓名">{{ detailData.name }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detailData.mobile || '--' }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ detailData.sex === 1 ? '男' : detailData.sex === 2 ? '女' : '--' }}</el-descriptions-item>
        <el-descriptions-item label="生日">{{ detailData.birthday | dateFormat('YYYY-MM-DD') }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="detailData.status === 2 ? 'primary' : 'success'" size="small" effect="plain">
            {{ detailData.status === 2 ? '跟进中' : '已成交' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="来源">{{ getSourceName(detailData.source_id) }}</el-descriptions-item>
        <el-descriptions-item label="跟进人">{{ getFollowerName(detailData.follower_id) }}</el-descriptions-item>
        <el-descriptions-item label="跟进阶段">{{ getStepName(detailData.step_id) }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detailData.remark || '--' }}</el-descriptions-item>
        <el-descriptions-item label="添加时间">{{ detailData.add_time | dateFormat }}</el-descriptions-item>
        <el-descriptions-item label="最后跟进时间">{{ detailData.last_update_time | dateFormat }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

// ---------- Mock 数据配置 ----------
// 来源选项
const sourceOptions = [
  { id: 1, name: '官网注册' },
  { id: 2, name: '线下活动' },
  { id: 3, name: '渠道推荐' },
  { id: 4, name: '广告投放' },
  { id: 5, name: '其他' }
]
// 跟进人选项
const followerOptions = [
  { id: 1, name: '张经理' },
  { id: 2, name: '李顾问' },
  { id: 3, name: '王老师' },
  { id: 4, name: '赵主管' }
]
// 跟进阶段选项
const stepOptions = [
  { id: 1, name: '初步沟通' },
  { id: 2, name: '需求分析' },
  { id: 3, name: '方案报价' },
  { id: 4, name: '商务谈判' },
  { id: 5, name: '合同签订' }
]

const mockApi = {
  // 获取线索列表
  getClueList(params) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let clues = localStorage.getItem('edu_clue_mock_data')
        if (!clues) {
          const now = Math.floor(Date.now() / 1000)
          const initData = [
            { id: 1, name: '张三', mobile: '13812345678', sex: 1, birthday: now - 86400 * 365 * 20, add_time: now - 86400 * 10, company_id: 1, status: 2, remark: '有意向了解课程', source_id: 1, follower_id: 1, step_id: 1, is_del: 0, last_update_time: now - 86400 * 3 },
            { id: 2, name: '李四', mobile: '13987654321', sex: 2, birthday: now - 86400 * 365 * 25, add_time: now - 86400 * 8, company_id: 1, status: 2, remark: '需要跟进', source_id: 2, follower_id: 2, step_id: 2, is_del: 0, last_update_time: now - 86400 * 1 },
            { id: 3, name: '王芳', mobile: '15234567890', sex: 2, birthday: now - 86400 * 365 * 22, add_time: now - 86400 * 5, company_id: 1, status: 3, remark: '已报名', source_id: 3, follower_id: 1, step_id: 5, is_del: 0, last_update_time: now - 86400 * 2 },
            { id: 4, name: '赵磊', mobile: '18765432109', sex: 1, birthday: now - 86400 * 365 * 28, add_time: now - 86400 * 2, company_id: 1, status: 2, remark: '考虑中', source_id: 4, follower_id: 3, step_id: 3, is_del: 0, last_update_time: now },
          ]
          localStorage.setItem('edu_clue_mock_data', JSON.stringify(initData))
          clues = initData
        } else {
          clues = JSON.parse(clues)
        }

        let list = clues.filter(item => item.is_del === 0 && item.company_id === (params.company_id || 1))

        if (params.name) list = list.filter(item => item.name.includes(params.name))
        if (params.mobile) list = list.filter(item => item.mobile && item.mobile.includes(params.mobile))
        if (params.status !== '' && params.status !== undefined && params.status !== null) {
          list = list.filter(item => item.status === params.status)
        }

        // 排序
        if (params.sortField && params.sortOrder) {
          list.sort((a, b) => {
            const aVal = a[params.sortField] || 0
            const bVal = b[params.sortField] || 0
            return params.sortOrder === 'ascending' ? aVal - bVal : bVal - aVal
          })
        }

        const total = list.length
        const start = (params.pageNum - 1) * params.pageSize
        const data = list.slice(start, start + params.pageSize)
        resolve({ code: 200, data, total, msg: 'success' })
      }, 300)
    })
  },

  addClue(data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let clues = localStorage.getItem('edu_clue_mock_data')
        clues = clues ? JSON.parse(clues) : []
        const newId = clues.length > 0 ? Math.max(...clues.map(c => c.id)) + 1 : 1
        const newClue = {
          ...data,
          id: newId,
          is_del: 0,
          add_time: Math.floor(Date.now() / 1000),
          last_update_time: Math.floor(Date.now() / 1000)
        }
        clues.push(newClue)
        localStorage.setItem('edu_clue_mock_data', JSON.stringify(clues))
        resolve({ code: 200, msg: '添加成功', data: newClue })
      }, 300)
    })
  },

  updateClue(data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let clues = localStorage.getItem('edu_clue_mock_data')
        clues = clues ? JSON.parse(clues) : []
        const index = clues.findIndex(c => c.id === data.id)
        if (index !== -1) {
          clues[index] = { ...clues[index], ...data, last_update_time: Math.floor(Date.now() / 1000) }
          localStorage.setItem('edu_clue_mock_data', JSON.stringify(clues))
          resolve({ code: 200, msg: '更新成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  },

  deleteClue(id) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let clues = localStorage.getItem('edu_clue_mock_data')
        clues = clues ? JSON.parse(clues) : []
        const index = clues.findIndex(c => c.id === id)
        if (index !== -1) {
          clues[index].is_del = 1
          localStorage.setItem('edu_clue_mock_data', JSON.stringify(clues))
          resolve({ code: 200, msg: '删除成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  },

  updateStatus(id, status) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let clues = localStorage.getItem('edu_clue_mock_data')
        clues = clues ? JSON.parse(clues) : []
        const index = clues.findIndex(c => c.id === id)
        if (index !== -1) {
          clues[index].status = status
          clues[index].last_update_time = Math.floor(Date.now() / 1000)
          localStorage.setItem('edu_clue_mock_data', JSON.stringify(clues))
          resolve({ code: 200, msg: '状态更新成功' })
        } else {
          resolve({ code: 404, msg: '数据不存在' })
        }
      }, 300)
    })
  }
}

export default {
  name: 'clueList',
  filters: {
    dateFormat(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!timestamp) return '--'
      return moment(timestamp * 1000).format(format)
    }
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      submitLoading: false,
      searchForm: {
        name: '',
        mobile: '',
        status: null
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      followCount: 0,
      dealCount: 0,
      sortField: '',
      sortOrder: '',

      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        name: '',
        mobile: '',
        sex: null,
        birthday: null,
        status: 2,
        source_id: null,
        follower_id: null,
        step_id: null,
        remark: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [{ validator: validateMobile, trigger: 'blur' }]
      },

      detailVisible: false,
      detailData: {},

      sourceOptions,
      followerOptions,
      stepOptions
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const params = {
           access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id') || 1,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm,
          sortField: this.sortField,
          sortOrder: this.sortOrder
        }
        const res = await this.$axios.mallClueListP(params)
        if (res.code === 200) {
          this.tableData = res.data.data
          this.total = res.total
          // 统计数量
          const allRes = await mockApi.getClueList({ company_id: params.company_id, pageNum: 1, pageSize: 999 })
          if (allRes.code === 200) {
            this.followCount = allRes.data.filter(item => item.status === 2).length
            this.dealCount = allRes.data.filter(item => item.status === 3).length
          }
        } else {
          this.$message.error(res.msg || '数据加载失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('网络异常，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    searchSubmit() {
      this.pageNum = 1
      this.getList()
    },

    resetSearch() {
      this.searchForm = { name: '', mobile: '', status: null }
      this.pageNum = 1
      this.getList()
    },

    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.getList()
    },

    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.getList()
    },

    handleSortChange({ prop, order }) {
      if (prop === 'add_time') {
        this.sortField = 'add_time'
        this.sortOrder = order
        this.getList()
      }
    },

    addData() {
      this.dialogTitle = '新增线索'
      this.form = {
        id: null,
        name: '',
        mobile: '',
        sex: null,
        birthday: null,
        status: 2,
        source_id: null,
        follower_id: null,
        step_id: null,
        remark: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },

    goEdit(row) {
      this.dialogTitle = '编辑线索'
      this.form = {
        id: row.id,
        name: row.name,
        mobile: row.mobile,
        sex: row.sex,
        birthday: row.birthday,
        status: row.status,
        source_id: row.source_id,
        follower_id: row.follower_id,
        step_id: row.step_id,
        remark: row.remark
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },

    goDetail(row) {
      this.detailData = { ...row }
      this.detailVisible = true
    },

    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
           const  access_token=sessionStorage.getItem('token');
          const company_id = sessionStorage.getItem('company_id') || 1
          const submitData = { ...this.form, company_id,access_token }
          let res
          if (this.form.id) {
            res = await this.$axios.mallClueSave(submitData)
          } else {
            res = await this.$axios.mallClueSave(submitData)
          }
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('操作异常')
        } finally {
          this.submitLoading = false
        }
      })
    },

    handleDialogClosed() {
      if (this.$refs.formRef) this.$refs.formRef.resetFields()
    },

    handleDelete(row) {
      this.$confirm(`确定要删除线索"${row.name}"吗？删除后数据不可恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'alipay-message-box'
      }).then(async () => {
        try {
          let param={
              access_token:sessionStorage.getItem('token'),
              company_id :sessionStorage.getItem('company_id'),
              id:row.id
          }
          const res = await this.$axios.mallClueDel(param);
          if (res.code === 200) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.pageNum > 1) this.pageNum--
            this.getList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('删除异常')
        }
      }).catch(() => {})
    },

    async handleCommand(command, row) {
      switch (command) {
        case 'detail':
          this.goDetail(row)
          break
        case 'toDeal':
          await this.changeStatus(row, 3)
          break
        case 'toFollow':
          await this.changeStatus(row, 2)
          break
      }
    },

    async changeStatus(row, status) {
      const action = status === 3 ? '已成交' : '跟进中'
      this.$confirm(`确定将线索"${row.name}"标记为${action}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'alipay-message-box'
      }).then(async () => {
        try {
          const res = await mockApi.updateStatus(row.id, status)
          if (res.code === 200) {
            this.$message.success(`已标记为${action}`)
            this.getList()
          } else {
            this.$message.error(res.msg || '状态更新失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('状态更新异常')
        }
      }).catch(() => {})
    },

    handleExport() {
      this.$message.info('导出功能开发中，实际可调用后端导出接口')
    },

    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
    },

    getSourceName(id) {
      const found = this.sourceOptions.find(item => item.id === id)
      return found ? found.name : '--'
    },
    getFollowerName(id) {
      const found = this.followerOptions.find(item => item.id === id)
      return found ? found.name : '--'
    },
    getStepName(id) {
      const found = this.stepOptions.find(item => item.id === id)
      return found ? found.name : '--'
    }
  }
}
</script>

<style lang="scss" scoped>
// 支付宝风格变量（与供货商列表完全一致）
$primary-color: #1677ff;
$success-color: #00b42a;
$danger-color: #f53f3f;
$warning-color: #ff7d00;
$text-primary: #1f2d3d;
$text-regular: #4e5969;
$text-secondary: #86909c;
$border-color: #e5e6eb;
$bg-gray: #f7f8fa;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);

.clue-container {
  padding: 20px 24px;
  background: $bg-gray;
  min-height: calc(100vh - 84px);
}

/* 页面头部 */
.page-header {
  margin-bottom: 20px;
  .header-left .el-breadcrumb {
    margin-bottom: 12px;
    ::v-deep .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: $text-secondary;
        font-size: 13px;
        &.is-link {
          color: $primary-color;
          &:hover { color: lighten($primary-color, 10%); }
        }
      }
      &:last-child .el-breadcrumb__inner {
        color: $text-primary;
        font-weight: 500;
      }
    }
  }
}

/* 统计卡片 */
.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  .stat-card {
    flex: 1;
    background: white;
    border-radius: 16px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: $card-shadow;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
      border-color: rgba($primary-color, 0.1);
    }
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      &.icon-total { background: rgba($primary-color, 0.1); color: $primary-color; }
      &.icon-follow { background: rgba($warning-color, 0.1); color: $warning-color; }
      &.icon-deal { background: rgba($success-color, 0.1); color: $success-color; }
    }
    .stat-info {
      flex: 1;
      .stat-label { font-size: 13px; color: $text-secondary; margin-bottom: 4px; }
      .stat-number { font-size: 28px; font-weight: 600; color: $text-primary; line-height: 1.2; }
    }
  }
}

/* 筛选卡片 */
.filter-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body { padding: 20px 24px; }
  .filter-header {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid $border-color;
    .filter-icon { color: $primary-color; font-size: 18px; margin-right: 8px; }
    .filter-title { font-size: 15px; font-weight: 600; color: $text-primary; }
  }
  .filter-form {
    .filter-row {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: flex-end;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0;
      .el-form-item__label { font-weight: 500; color: $text-regular; font-size: 13px; }
      .el-input__inner, .el-select .el-input__inner {
        border-radius: 8px;
        border-color: $border-color;
        &:focus {
          border-color: $primary-color;
          box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
        }
      }
    }
    .action-buttons {
      margin-left: auto;
      .search-btn, .reset-btn, .add-btn {
        border-radius: 20px;
        padding: 8px 20px;
        font-weight: 500;
      }
      .search-btn { background: $primary-color; border: none; &:hover { background: lighten($primary-color, 8%); } }
      .reset-btn { border-color: $border-color; color: $text-regular; &:hover { border-color: $primary-color; color: $primary-color; } }
      .add-btn { background: $primary-color; border: none; box-shadow: 0 2px 4px rgba(22,119,255,0.2); &:hover { background: lighten($primary-color, 8%); transform: translateY(-1px); } }
    }
  }
}

/* 表格卡片 */
.table-card {
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body { padding: 20px 24px; }
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid $border-color;
    .table-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
      .table-icon { color: $primary-color; font-size: 18px; }
      .table-title { font-size: 16px; font-weight: 600; color: $text-primary; }
      ::v-deep .el-tag { background: $bg-gray; border: none; color: $text-secondary; }
    }
    .table-header-right .el-button {
      color: $text-secondary;
      &:hover { color: $primary-color; background: rgba($primary-color,0.05); }
    }
  }
}

/* 表格样式优化 */
::v-deep .el-table {
  font-size: 13px;
  border-radius: 12px;
  overflow: hidden;
  th { background: $bg-gray !important; color: $text-secondary; font-weight: 500; padding: 12px 0; border-bottom: 1px solid $border-color; }
  td { padding: 14px 0; border-bottom: 1px solid $border-color; }
  .even-row { background: #ffffff; }
  .odd-row { background: #fbfbfc; }
  .hover-row > td { background: rgba($primary-color, 0.02) !important; }
  .el-table__sort-icon { color: $text-secondary; &.ascending, &.descending { color: $primary-color; } }
}

/* 单元格内容 */
.clue-name, .contact-phone, .address-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  i { color: $text-secondary; font-size: 13px; }
  span { color: $text-regular; }
}
.name-text { font-weight: 500; color: $text-primary; }
.remark-text, .time-text { color: $text-secondary; font-size: 12px; }
.index-badge {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background: $bg-gray;
  color: $text-secondary;
  border-radius: 13px;
  font-size: 12px;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  .edit-btn { color: $primary-color; &:hover { background: rgba($primary-color,0.08); } }
  .delete-btn { color: $danger-color; &:hover { background: rgba($danger-color,0.08); } }
  .more-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 14px;
    cursor: pointer;
    color: $text-secondary;
    &:hover { background: rgba($text-secondary,0.1); color: $primary-color; }
    i { font-size: 16px; }
  }
}

/* 分页 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  margin-top: 16px;
  border-top: 1px solid $border-color;
  ::v-deep .el-pagination {
    .el-pagination__total, .el-pagination__jump { color: $text-secondary; font-size: 13px; }
    .btn-prev, .btn-next, .el-pager li { border-radius: 8px; margin: 0 4px; font-weight: 500; &:hover { color: $primary-color; } }
    .el-pager li.active { background: $primary-color; color: white; &:hover { background: lighten($primary-color,8%); } }
    .el-select .el-input__inner { border-radius: 8px; }
  }
}

/* 弹窗样式 */
::v-deep .alipay-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 35px -8px rgba(0,0,0,0.2);
    .el-dialog__header { border-bottom: 1px solid $border-color; padding: 20px 24px; .el-dialog__title { font-size: 18px; font-weight: 600; color: $text-primary; } }
    .el-dialog__body { padding: 24px; }
    .el-dialog__footer { border-top: 1px solid $border-color; padding: 16px 24px; }
  }
  .el-form-item__label { font-weight: 500; color: $text-regular; }
  .el-input__inner, .el-textarea__inner { border-radius: 8px; border-color: $border-color; &:focus { border-color: $primary-color; box-shadow: 0 0 0 2px rgba($primary-color,0.1); } }
  .el-radio__input.is-checked .el-radio__inner { background: $primary-color; border-color: $primary-color; }
  .el-descriptions {
    .el-descriptions__label { background: $bg-gray; color: $text-regular; font-weight: 500; width: 100px; }
    .el-descriptions__content { color: $text-primary; }
  }
}

::v-deep .alipay-message-box {
  border-radius: 16px;
  .el-message-box__header { padding-top: 20px; .el-message-box__title { font-weight: 600; } }
  .el-message-box__btns button { border-radius: 20px; padding: 8px 20px; }
}

@media (max-width: 1200px) {
  .stats-row { flex-direction: column; gap: 12px; .stat-card { padding: 16px 20px; } }
  .filter-form .filter-row {
    flex-direction: column;
    align-items: stretch;
    .el-form-item { width: 100%; }
    .action-buttons { margin-left: 0; display: flex; gap: 12px; .el-button { flex: 1; text-align: center; } }
  }
}
@media (max-width: 768px) {
  .clue-container { padding: 16px; }
  .table-card ::v-deep .el-card__body { padding: 16px; }
  .action-buttons { flex-wrap: wrap; }
}
</style>